<template>
  <div>
    <div class="header">
      <!-- 一级目录 -->
      <div class="menuContainer">
        <!-- 首页 -->
        <div :class="-1 === choose ? 'selectMenuClass' : 'noSelectMenuClass'" @click="getIndex(-1)" v-if="dashboard">
          <!-- 个人首页 -->
          <span> {{ $t('message.index') }}</span>
        </div>
        <!-- 接口返回的 -->
        <div v-for="(item, index) in menu" :key="item.id"
          :class="index === choose ? 'selectMenuClass' : 'noSelectMenuClass'" @click="updateSelectMenu(item, index)"
          v-show="item.name != '客户授权管理' && item.show">
          <span v-if="locale == 'zh'"> {{ item.name }}</span>
          <span v-else-if="locale == 'ja'"> {{ item.name_ja ? item.name_ja : item.name }}</span>
        </div>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link noSelectMenuClass">
            关联系统<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="remark_type == 2 || canShowAllRelatedSystem" command="1688">1688后台</el-dropdown-item>
            <el-dropdown-item command="goYiwu">管理系统</el-dropdown-item>
            <el-dropdown-item command="goWuliu" v-if="canShowRelatedSystem(['业务'])">物流比对</el-dropdown-item>
            <el-dropdown-item command="businessAbnormalParcel"
              v-if="canShowRelatedSystem(['业务'])">异常包裹</el-dropdown-item>
            <el-dropdown-item command="supplierSystem"
              v-if="canShowRelatedSystem(['业务','财务'])">供应商系统</el-dropdown-item>
            <el-dropdown-item command="introducer" v-if="canShowRelatedSystem(['财务'])">讲师系统</el-dropdown-item>
            <el-dropdown-item command="operation" v-if="canShowRelatedSystem([])">运营系统</el-dropdown-item>
          </el-dropdown-menu>


        </el-dropdown>
        <!-- <div class="noSelectMenuClass" @click="getAlibabaOrTaobaoUsWebToken" v-if="remark_type == 5">
        </div>
        <div class="noSelectMenuClass" @click="goYiwu">
        </div> -->
      </div>
      <div class="userInfo fr">
        <!-- 汇率 -->
        <span style="margin-right: 10px;">{{ $t("message.rate") }}:{{ rate }}</span>
        <!--        语言-->
        <span> {{ $t("message.language") }} :</span>
        <el-select v-model="value" @change="setLang" size="mini" style="margin-right: 20px">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <img src="../../assets/icon/chat.png" class="chat" @click="chat" />

        <!-- 包裹下拉菜单 hover -->
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <img :src="pic" alt="" class="pic">
            <!--            业务员-->
            {{ userInfo.realname
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logOut">{{
              $t("message.logOut")
            }}</el-dropdown-item>
            <!-- 修改密码 -->
            <el-dropdown-item command="password">{{
              $t("message.editPassword")
            }}</el-dropdown-item>
            <!-- 修改头像 -->
            <el-dropdown-item command="editPic">{{
              $t("message.editPic")
            }}</el-dropdown-item>
            <!-- 微信授权 -->
            <el-dropdown-item command="wechatAuthorization">
              <span :style="{ color: userInfo.admin_wx_work != null ? '#B4272D ' : '' }">
                {{
                  $t("message.enterpriseWechatAuthorization")
                }}
              </span>
            </el-dropdown-item>
            <!-- 指纹采集 -->
            <!-- <el-dropdown-item command="fingerprintCollection">{{
              $t("message.fingerprintCollection")
            }}</el-dropdown-item> -->
          </el-dropdown-menu>

        </el-dropdown>
      </div>
      <!-- 通知 -->
      <div class="notification" @click="read" v-if="unreadNoticeNum">
        <img src="../../assets/icon/notification.gif" alt="">
        <span>{{ unreadNoticeNum }}</span>
      </div>
    </div>
    <!-- 修改头像 -->
    <editPic ref="editPic" />
    <!-- 修改密码 -->
    <editPassword ref="editPassword" />
    <!-- 通知 -->
    <notification ref="notification" />
    <!-- 微信授权 -->
    <wechatAuthorization ref="wechatAuthorization" />
    <!-- 指纹采集 -->
    <fingerprintCollection ref="fingerprintCollection" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import editPic from './editPic'
import editPassword from './editPassword.vue'
import notification from './notification'
import wechatAuthorization from './wechatAuthorization'
import fingerprintCollection from './fingerprintCollection.vue'
export default {
  components: {
    editPic,
    editPassword,
    notification,
    wechatAuthorization,
    fingerprintCollection
  },
  data() {
    return {
      time: "",
      value: this.$i18n.locale,
      options: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "ja",
          label: "日本語",
        },
      ],
      choose: -1,
      token: localStorage.getItem('japan_access_token'),
      remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
      workTypeName: '',
      pic: localStorage.getItem("japanUserRoleInfo") ? JSON.parse(localStorage.getItem("japanUserRoleInfo")).pic : '',
      unreadNoticeNum: 0,
      japanUserRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo'))
    };
  },
  computed: {
    userInfo() {
      if (localStorage.getItem("japanUserRoleInfo")) {
        return JSON.parse(localStorage.getItem("japanUserRoleInfo"));
      } else {
        return {};
      }
    },
    // 是否隐藏首页
    dashboard() {
      let flag = this.userInfo.auth_field_list.find(item => item.id == 34)
      return !flag
    },
    menu() {
      let menu = JSON.parse(localStorage.getItem("menu"));
      if (menu) {
        return menu;
      } else {
        return this.$store.state.menu;
      }

    },
    locale() {
      return this.$i18n.locale
    },
    ...mapState({
      menu: "menu",
    }) /* 推荐 */,
    rate() {
      return this.$store.state.rate
    },
    // 账号 104、13、502、504 可看全部关联系统
    canShowAllRelatedSystem() {
      return [104, 13, 502, 504,].includes(Number(this.japanUserRoleInfo && this.japanUserRoleInfo.id))
    },
  },
  created() {
    this.$store.dispatch("orderStatusMap");
    this.$store.dispatch("typeList");
    this.$store.dispatch("orderDetailStatusMap");
    this.$store.dispatch("getAuthWorkGroupAdmin");
    this.$store.dispatch("getOrganizationList");
    this.$store.dispatch("getProblemTypes");
    this.$store.dispatch("getExchangeRat");
    this.getMenuIndex();
    this.getCurrentWorkType();
    this.unreadNotice()
  },
  mounted() {
  },
  methods: {
    // 获取当前账号工种名称，供关联系统入口控制使用
    getCurrentWorkType() {
      this.$api.roleApi.worktypeList().then(res => {
        const workType = res.data.find(item => item.id == this.remark_type)
        this.workTypeName = workType ? workType.work_name : ''
      })
    },
    // Y001、M001、白名单账号不受工种限制，其余账号按配置的工种显示（已取消运营工种）
    canShowRelatedSystem(workTypeList) {
      if (this.canShowAllRelatedSystem) return true
      if (['Y001', 'M001'].includes(this.japanUserRoleInfo.username)) return true
      return workTypeList.includes(this.workTypeName)
    },
    // 通知
    unreadNotice() {
      this.$api.siteConfiguration.unreadNotice().then(res => {
        this.unreadNoticeNum = res.data.length
        // console.log(res);
      })
    },
    getMenuIndex() {
      let route = this.$route.name;
      this.menu.forEach((item, index) => {
        item.child_menus.forEach((items) => {
          items.child_menus.forEach((itemss) => {
            if (itemss.route == route) {
              this.updateSelectMenu(item, index);
            }
          });
        });
      });
    },
    // 下拉菜单
    handleCommand(command) {
      if (command == "logOut") {
        this.logOut();
      } else if (command == "password") {
        this.$refs.editPassword.dialogVisible = true;
      } else if (command == "editPic") {
        this.$refs.editPic.dialogVisible = true
      } else if (command == "1688") {
        this.getAlibabaOrTaobaoUsWebToken()
      } else if (command == "goYiwu") {
        this.goYiwu()
      } else if (command == "goWuliu") {
        this.goWuliu()
      }
      else if (command == "introducer") {
        this.introducer()
      } else if (command == "businessAbnormalParcel") {
        this.businessAbnormalParcel()
      } else if (command == "supplierSystem") {
        this.supplierSystem()
      } else if (command == 'wechatAuthorization') {

        if (this.userInfo.admin_wx_work == null) {
          this.$refs.wechatAuthorization.openDialog()
        } else {
          this.$alert('账号已授权，如需修改授权请提交工单处理', '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {

            }
          });
        }
      } else if (command == 'operation') {
        this.operation()
      } else if (command == 'fingerprintCollection') {
        // 检查是否绑定指纹
        this.$api.roleApi.fingerprintHasBound().then(res => {
          if (!res.data.bound) {
            this.$refs.fingerprintCollection.openDialog()
          } else {
            this.$alert('账号已绑定指纹，如需修改请提交工单处理', '提示', {
              confirmButtonText: '确定',
              center: true,
              callback: action => {

              }
            });
          }

        })
      }



    },

    // 退出登录
    logOut() {
      this.$router.push("/login");
      localStorage.removeItem("japan_access_token");
      localStorage.removeItem("userRoleInfo");
      localStorage.removeItem("menu");
      localStorage.removeItem("userAuth");
    },
    updateSelectMenu(item, index) {
      this.choose = index;
      this.$store.commit("setLeftMenu", item.child_menus);
    },
    // 语言切换
    setLang() {
      this.$i18n.locale = this.value;
      localStorage.setItem('locale', this.value)
      // this.$router.go(0)
      this.$forceUpdate();
    },
    chat() {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      window.open(
        `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&token=${token}`,
        japanUserRoleInfo,
        "height=700, width=1260, left=" +
        iLeft +
        ", top=" +
        iTop +
        ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
      );

    },
    // 时区
    getLocalTime(i) {
      //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== "number") return;
      var d = new Date();
      //得到1970年一月一日到现在的秒数
      var len = d.getTime();
      //本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000;
      //得到现在的格林尼治时间
      var utcTime = len + offset;
      return new Date(utcTime + 3600000 * i);
    },
    // 获取时区
    getCurrentDate(i) {
      var time = "";
      var now = this.getLocalTime(i);
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      return (time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec);
    },
    //获取1688或淘宝自建后台的token
    getAlibabaOrTaobaoUsWebToken() {
      this.$api.getAlibabaOrTaobaoUsWebToken().then(res => {
        let link = 'http://alibaba.rakumart.cn/#/getToken?token=' + res.data.alibaba_or_taobao_my_web_token

        window.open(link)
      })
    },
    //讲师系统
    introducer() {
      let link = 'https://admin5.rakumart.com/index.php?mod=admin&act=gk&id=' + this.japanUserRoleInfo.id
      window.open(link)
    },
    //义乌人员管理系统
    goYiwu() {
      let link = 'https://staff.rakumart.cn/raku_admin/index.html#/home?userName=' + this.japanUserRoleInfo.realname
      window.open(link)
    },
    // 物流管理系统
    goWuliu() {
      let link = ''
      link = 'https://logisic.rakumart.cn/#/login?token=' + localStorage.getItem('japan_access_token')
      window.open(link)
    },
    // 异常包裹
    businessAbnormalParcel() {
      let link = ''
      link = 'https://logisic.rakumart.cn/#/businessAbnormalParcel?token=' + localStorage.getItem('japan_access_token')
      window.open(link)
    },
    // 供应商系统
    supplierSystem() {
      let link = 'https://spm.rakumade.com/login?id=' + this.japanUserRoleInfo.id
      window.open(link)
    },
    // 查看未读
    read() {
      this.$refs.notification.dialogVisible = true
    },
    //个人首页
    getIndex(i) {
      this.choose = i;
      if (this.$route.name != 'homePage') {
        this.$router.push('homePage')
      } else {
        this.$router.go(0)
      }

    },
    //运营系统
    operation() {
      let link = ''
      link = ' http://operation.rakumart.cn/#/dataBurialPoint?token=' + localStorage.getItem('japan_access_token')
      window.open(link)

    },

  },
};
</script>
<style lang='scss' scoped>
.header {
  //overflow: hidden;
  height: 72px;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @keyframes example {
    0% {
      opacity: 0;
      // background-color: #fff;
      // color: #b4272d;
    }

    50% {
      opacity: 1;
      // color: #fff;
      // background-color: #b4272d;
    }

    100% {
      opacity: 0;
      // background-color: #fff;
      // color: #b4272d;
    }

  }

  .notification {
    position: absolute;
    bottom: -50px;
    right: 50px;
    width: 50px;
    height: 50px;

    color: #fff;
    border-radius: 50%;
    line-height: 50px;
    text-align: center;
    z-index: 99;
    cursor: pointer;

    img {
      width: 30px;
    }

    span {
      position: absolute;
      top: -8px;
      width: 32px;
      height: 20px;
      color: #fff;
      background-color: #b4272d;
      right: -3px;
      line-height: 20px;
      border-radius: 10px;
      font-size: 14px;
      animation: example 2s infinite;
    }

  }

  h1 {
    margin-right: 100px;
    padding: 10px 0 0 20px;
    line-height: 40px;
    cursor: pointer;

    img {
      width: 154px;
      height: 40px;
    }
  }

  .menuContainer {
    display: flex;
    align-items: center;
    margin-left: 24px;

    .noSelectMenuClass,
    .selectMenuClass {
      font-weight: 400;
      color: #333333;
      background: #f8f8f8;
      height: 72px;
      box-sizing: border-box;
      padding: 30px 25px;
      margin-right: 14px;
      cursor: pointer;
    }

    .selectMenuClass {
      color: #fff;
      background: #b4272d;
    }
  }

  .userInfo {
    font-size: 14px;
    height: 30px;
    margin: 0px 20px 0 0;
    line-height: 30px;

    img {
      height: 16px;
      margin-right: 10px;
      vertical-align: middle;
      cursor: pointer;
    }

    span {
      display: inline-block;
      // margin: 0 10px 0 40px;
    }

    .pic {
      width: 30px;
      height: 30px;

      border-radius: 50%;
    }
  }
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 240px;
}

.language {
  display: inline-block;

  span {
    display: inline-block;
    width: 80px;
    margin: 0;
  }
}
</style>
